import Container from "@/Components/Grid/Container";

import Wejscie from "@resources/show-apartment/gallery/wejscie.jpg?format=webp&quality=80&w=800;600;400&as=srcset&imagetools";
import Kuchnia from "@resources/show-apartment/gallery/kuchnia.jpg?format=webp&quality=80&w=800;600;400&as=srcset&imagetools";
import Salon from "@resources/show-apartment/gallery/salon.jpg?format=webp&quality=80&w=800;600;400&as=srcset&imagetools";
import Korytarz from "@resources/show-apartment/gallery/korytarz.jpg?format=webp&quality=80&w=800;600;400&as=srcset&imagetools";

const photos = [
    {
        key: "wejscie",
        image: Wejscie,
        label: "Wejście",
        objectPosition: "object-center",
    },
    {
        key: "kuchnia",
        image: Kuchnia,
        label: "Kuchnia",
        objectPosition: "object-[20%_center]",
    },
    {
        key: "salon",
        image: Salon,
        label: "Salon",
        objectPosition: "object-center",
    },
    {
        key: "korytarz",
        image: Korytarz,
        label: "Korytarz",
        objectPosition: "object-center",
    },
];

export const ShowApartmentGallery = () => {
    return (
        <section id="show-apartment-gallery" className="py-14 lg:py-18">
            <Container>
                <h2 className="text-primary text-h3 leading-[40px] font-extrabold uppercase tracking-[0.8px] text-center mb-[60px] maxMd:mb-10">
                    Zobacz wnętrza mieszkania pokazowego
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
                    {photos.map((photo) => (
                        <div
                            key={photo.key}
                            className="relative h-[279px] rounded-2xl overflow-hidden"
                        >
                            <img
                                srcSet={photo.image}
                                alt={photo.label}
                                className={`absolute inset-0 size-full object-cover ${photo.objectPosition}`}
                                loading="lazy"
                            />
                            <span className="button-small absolute left-4 bottom-4 bg-primary text-white border-primary pointer-events-none">
                                {photo.label}
                            </span>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
};
